<template>
  <v-app>
    <SonyEnvironmentSystemBar />
    <v-app-bar app dark class="bg-black">
      <SelectedProgram v-if="!loading"></SelectedProgram>
      <SelectedProgramDropdown class="pr-15"></SelectedProgramDropdown>
      <v-spacer></v-spacer>
      <country-flag v-if="this.selectedCountry.name == 'USA'" country="usa" size="normal" />
      <country-flag v-if="this.selectedCountry.name == 'CAN'" country="can" size="normal" />
      <LocaleDropdown :routeToDashboard="false"></LocaleDropdown>
      <template v-slot:extension>
        <CeurTopMenu></CeurTopMenu>
      </template>
    </v-app-bar>
    <v-main class="login-bg" v-if="!loading">
      <router-view></router-view>
    </v-main>
    <v-footer absolute>
      <Footer></Footer>
    </v-footer>
  </v-app>
</template>

<script>
import CountryFlag from "vue-country-flag";
import Footer from "../../components/Footer.vue";
import SelectedProgram from "../../components/SelectedProgram.vue";
import LocaleDropdown from "../../gapp-components/components/fields/LocaleDropdown.vue";
import SelectedProgramDropdown from "../../gapp-components/components/fields/SelectedProgramDropdown.vue";
import SonyEnvironmentSystemBar from "../SonyEnvironmentSystemBar.vue";
import CeurTopMenu from "./CeurTopMenu.vue";

import { mapGetters } from "vuex";

export default {
  name: "LayoutPublicCeur",
  components: {
    CountryFlag,
    SonyEnvironmentSystemBar,
    SelectedProgram,
    SelectedProgramDropdown,
    LocaleDropdown,
    CeurTopMenu,
    Footer
  },
  data: () => ({
    loading: true
  }),
  async mounted() {
    this.loading = true;
    let programKey = this.$sonyProgram.getProgramKeyByDomain();
    await this.$api
      .get("/api/programs/byKey/" + programKey + "/public")
      .then(({ data }) => {
        let program = data;
        return Promise.all([
          this.$auth.storeSelectProgram(program),
          this.$auth.storeSelectClient(program.programGroup.client)
        ]);
      })
      .finally(() => {
        this.loading = false;
      });
  },
  computed: {
    ...mapGetters(["selectedProgram", "selectedCountry"])
  }
};
</script>
